// Centralizes where uni-admin auth tokens live so every reader/writer
// (authService, the axios interceptors, refresh flow) agrees on the same
// storage. "Remember me" moves tokens into localStorage (survives browser
// restarts); otherwise they stay in sessionStorage (cleared on tab close).
const ACCESS_KEY = "uniAdminAccessToken";
const REFRESH_KEY = "uniAdminRefreshToken";
const REMEMBER_KEY = "uniAdminRememberMe";

const isRemembered = () => localStorage.getItem(REMEMBER_KEY) === "true";

const getStorage = () => (isRemembered() ? localStorage : sessionStorage);

export function setTokens(accessToken, refreshToken, remember) {
  // Clear both storages first so a stale copy never lingers in the storage
  // that's no longer active (e.g. switching remember-me off on next login).
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);

  localStorage.setItem(REMEMBER_KEY, remember ? "true" : "false");

  const storage = remember ? localStorage : sessionStorage;
  storage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) storage.setItem(REFRESH_KEY, refreshToken);
}

export function updateTokens(accessToken, refreshToken) {
  const storage = getStorage();
  storage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) storage.setItem(REFRESH_KEY, refreshToken);
}

export function getAccessToken() {
  return getStorage().getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return getStorage().getItem(REFRESH_KEY);
}

export function clearTokens() {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(REMEMBER_KEY);
}
